import axios from "axios";
import router from "@/pages/health/router";

let needLoadingRequestCount = 0;
export default {
  install(Vue, options) {
    const cathayAxios = axios.create({
      baseURL: process.env.VUE_APP_API_HOST,
      withCredentials: true,
      headers: {
        get: {
          Accept: "application/json",
          Pragma: "no-cache",
          "Cache-Control": "no-cache, no-store"
        },
        post: {
          "Content-Type": "application/json"
        },
        put: {
          "Content-Type": "application/json"
        },
        download: {
          "Content-Type": "application/json"
        },
        delete: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }
    });

    const showRtnMessage = options.conf.SHOW_RTNMESSAGE != false;
    cathayAxios.interceptors.response.use(
      response => {
        tryHideFullScreenLoading();
        const resp = {};
        if (process.env.VUE_APP_API_MODE === "json-server") {
          if (response.status >= 200 && response.status <= 299) {
            resp.data = {};
            resp.data.returnCode = 0;
            resp.data.msg = "";
            resp.data.data = response.data;
            return resp.data;
          }

          Vue.$notify.error(response.data.msg || "伺服器維護中，請稍候再試!");
          return response.data;
        }
        if (response.data && response.data.returnCode == 0) {
          if (
            response.data.msg &&
            response.data.msg.length > 0 &&
            showRtnMessage
          ) {
            Vue.$notify.success(response.data.msg);
          }
          return response.data;
        }

        if (response.data && response.data.returnCode == 403) {
          router.push({
            name: "ODBAF201",
            params: { errorCode: "004" }
          });
          return response.data;
        }

        const url = response.config.url;
        if (!url.includes("api/DTODBA08") && !url.includes("api/DTODBA09")) {
          Vue.$notify.error(response.data.msg || "伺服器維護中，請稍候再試!");
        }
        return response.data;
      },
      error => {
        tryHideFullScreenLoading();
        Vue.$notify.error("伺服器維護中，請稍候再試!");
        return Promise.resolve(error);
      }
    );

    cathayAxios.interceptors.request.use(config => {
      if (["development", "testing"].indexOf(process.env.NODE_ENV) > -1) {
        /* eslint-disable no-console */
        /* 這裡已有判斷僅在開發、測試環境會顯示console */
        console.log("[CathayAxios] Request Url: " + config.url);
        /* eslint-enable no-console */
        if (process.env.VUE_APP_API_MODE === "static") {
          config.url = "static/data/" + config.url.split("?")[0] + ".json";
        }
      }

      showFullScreenLoading();
      return config;
    });

    Vue.prototype.$cathayAxios = (method, url, req) => {
      switch (method) {
        case "get":
          Vue.$cathayAxios.get(url, body);
          break;
        case "post":
          Vue.$cathayAxios.post(url, body);
          break;
        case "put":
          Vue.$cathayAxios.put(url, body);
          break;
        case "delete":
          Vue.$cathayAxios.delete(url, body);
          break;
        case "download":
          Vue.$cathayAxios.download(url, body);
          break;
        default:
          Vue.$notify.error("伺服器維護中，請稍候再試!");
      }
    };

    Vue.$cathayAxios = Vue.prototype.$cathayAxios;

    Vue.prototype.$cathayAxios.get = (url, param) => {
      return cathayAxios.get(url, { params: param });
    };
    Vue.prototype.$cathayAxios.post = (url, body) => {
      return cathayAxios.post(url, body);
    };
    Vue.prototype.$cathayAxios.put = (url, body) => {
      return cathayAxios.put(url, body);
    };
    Vue.prototype.$cathayAxios.delete = (url, body) => {
      return cathayAxios.delete(url, { data: body });
    };

    Vue.prototype.$cathayAxios.upload = (url, body) => {
      let _url = url;
      if (process.env.VUE_APP_API_HOST != "/") {
        _url = process.env.VUE_APP_API_HOST + "/" + url;
      }
      showFullScreenLoading();
      return axios
        .post(_url, body, {
          headers: {
            "Content-Type": " multipart/form-data;",
            "X-Requested-With": "XMLHttpRequest"
          },
          withCredentials: true
        })
        .then(response => {
          tryHideFullScreenLoading();
          if (response.data && response.data.returnCode == 0) {
            if (
              response.data.msg &&
              response.data.msg.length > 0 &&
              showRtnMessage
            ) {
              Vue.$notify.success(response.data.msg);
            }
            return Promise.resolve(response.data);
          }

          Vue.$notify.error(response.data.msg);
          return Promise.resolve(response.data);
        })
        .catch(error => {
          tryHideFullScreenLoading();
          Vue.$notify.error("上傳檔案至伺服器發生錯誤!");
          return Promise.resolve(error);
        });
    };

    Vue.prototype.$cathayAxios.download = (url, body, name) => {
      let _url = url;
      if (process.env.VUE_APP_API_HOST != "/") {
        _url = process.env.VUE_APP_API_HOST + "/" + url;
      }
      showFullScreenLoading();
      return new Promise((resolve, reject) => {
        axios
          .post(_url, body, {
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "blob",
            withCredentials: true,
          })
          .then(resp => {
            tryHideFullScreenLoading();
            if (!resp.data) {
              // 後端回的是錯誤訊息（JSON）而不是檔案
              transBlobToObject(resp.data, function (data) {
                Vue.$notify.error("下載失敗! " + data.msg);
                resolve(data);
              });
            } else {
              resolve(download(resp.data, `${name}.xls`));
            }
          })
          .catch(err => {
            tryHideFullScreenLoading();
            reject(err);
          });
      });
    };

    function download(data, fileName) {
      if (!data) return;
      const blob = new Blob([data], {
        type: "application/octet-stream"
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // FOR IE
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    }

    // function serializeParam(param) {
    //   var str = "";
    //   for (var key in param) {
    //     if (str != "") {
    //       str += "&";
    //     }
    //     str += encodeURIComponent(key) + "=" + encodeURIComponent(param[key]);
    //   }

    //   return str;
    // }

    function showFullScreenLoading() {
      if (!Vue.$loader) return;
      if (needLoadingRequestCount === 0) {
        Vue.$loader.open();
      }
      needLoadingRequestCount += 1;
    }

    function tryHideFullScreenLoading() {
      if (!Vue.$loader) return;
      if (needLoadingRequestCount <= 0) return;

      needLoadingRequestCount -= 1;
      if (needLoadingRequestCount === 0) {
        setTimeout(function () {
          Vue.$loader.close();
        }, 500);
      }
    }

    function transBlobToObject(blob, callBack) {
      reader.onload = function () {
        callBack(JSON.parse(this.result));
      };
      reader.readAsText(blob);
    }

    // create FileReader
    const reader = new FileReader();
  }
};
